import React from "react";

import { PlayPart } from "./components/PlayPart";
import { MainAboutGame } from "./components/MainAboutGame";
// import { NextDropPart } from "./components/NextDropPart";
// import { NextDropTimerPart } from "./components/NextDropTimerPart";
import { ForInfluencersPart } from "./components/ForInfluencersPart";
import { ForGamersPart } from "./components/ForGamersPart";
import { PartnersPart } from "./components/PartnersPart";

export const Main: React.FC = React.memo(() => {
  return (
    <div>
      <PlayPart />
      <MainAboutGame />
      <ForInfluencersPart />
      <ForGamersPart />
      {/*<NextDropPart />*/}
      {/*<NextDropTimerPart />*/}
      <PartnersPart />
    </div>
  );
});
